/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name shiftweek
 */
angular.module('mercury.modules.time.roster')
.directive('shiftweek', ["$timeout", "reporttime", function($timeout, reporttime) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element) {
      //If the cell has to be disabled because the roster that the cell belongs to is published then we don't want
      //the week-cell class and we also don't want the user to be able to click on the cell and keep adding/updating shifts
      var disableEvents = scope.days != null && scope.days[scope.dayIndex] ? scope.disableCell(scope.days[scope.dayIndex].startTime) : false;

      if (!disableEvents) {
        var isMobile = function() {
          return 'ontouchstart' in window || navigator.maxTouchPoints;
        };

        var dragDelay = (isMobile()) ? 500 : 0;
        var startTouchDragEditorScroll = null;
        var editorBody = angular.element('#editor-container');

        var endMemberId = null;
        var endDay = null;

        var onOverCallback = function(member, day) {

          // The day variable provided to us tells us what company day the
          // shift is being moved to. However, for a shift that starts after
          // midnight and before the company/view start time that is incorrect
          // for what we use this variable for (updating the date of the clockin
          // via an API call). To fix this we check for the shift beginning
          // before the company/view time and bump the day up by one when necessary.
          if (isBeforeViewStartTime(scope.shift.clockinTime)) {
            day = day + 1
          }

          endMemberId = member.id;
          endDay = day;
        };

        /**
         * Helper function that will return true if the provided datetime is
         * before the view start time.
         *
         * Note that the view start time in most cases matches the company start
         * time. However, when viewing a template that was created before a
         * company time change on the company the view start date can be different.
         * @param {*} datetimeToCheck
         * @returns
         */
        var isBeforeViewStartTime = function(datetimeToCheck) {
          // We only want to compare times, but moment only deals with datetimes.
          // To do a time comparasion we chose a random date and create two moments
          // with the times we want to compare.
          var randomDay = moment('2024-09-01T00:00:00+00:00')

          var viewStartMoment = randomDay.clone()
            .hour(moment(scope.viewStartDateTime).hour())
            .minute(moment(scope.viewStartDateTime).minute())

          var datetimeToCheckMoment = randomDay.clone()
            .hour(moment(datetimeToCheck).hour())
            .minute(moment(datetimeToCheck).minute())

          return datetimeToCheckMoment.isBefore(viewStartMoment)
        }

        /**
         * Moves existing rostered shift breaks over to the new rostered shift day
         * This is used to ensure that as rostered shift elements move, it's corresponding breaks move with it
         */
        var moveBreaks = function(breaks, endDay) {
          angular.forEach(breaks, function(breakObj) {
            var breakStartMins = moment(breakObj.breakStart).diff(moment(breakObj.breakStart).mStartOf('day'), 'minutes');
            var breakEndMins = moment(breakObj.breakEnd).diff(moment(breakObj.breakEnd).mStartOf('day'), 'minutes');

            var momentViewStartDateTime = moment(scope.viewStartDateTime)
            breakObj.breakStart = moment(momentViewStartDateTime).add(endDay, 'days').add(breakStartMins, 'minutes').format();
            breakObj.breakEnd = moment(momentViewStartDateTime).add(endDay, 'days').add(breakEndMins, 'minutes').format();
          }, endDay);
          return breaks;
        };

        /**
         * Copies breaks over to the new shift element
         * This is used to ensure that as rostered shift elements are replicated and treated as new rostered 
         * shift entries, the breaks are copied and created alongside it
         */
        var copyBreaks = function(breaks, daysDiff) {
          angular.forEach(breaks, function(breakObj) {
            delete breakObj.id;
            delete breakObj.shiftId;
            breakObj.breakStart = moment(breakObj.breakStart).add(daysDiff, 'days').format();
            breakObj.breakEnd = moment(breakObj.breakEnd).add(daysDiff, 'days').format();
          }, daysDiff);

          return breaks;
        };

        /*
        * Configure the draggable shift to enable moving to a different staff member and day.
        */
        element.draggable({
          revert: 'invalid',
          revertDuration: 0,
          containment: editorBody,
          cancel: '.shift-control',
          delay: dragDelay,
          start: function(event, ui) {
            var currentEditorScroll = editorBody.scrollTop();
            if ((startTouchDragEditorScroll !== null && startTouchDragEditorScroll != currentEditorScroll) || scope.shift.saving) {
              //This kills the drag
              event.preventDefault();
              return;
            }

            //We can't add this check in the previous if statement because that will cause the line
            //to be too long and it breaks angular build
            if (scope.shift.datestampLocked != null) {
              event.preventDefault();
              return;
            }

            if (isMobile()) {
              editorBody.css('overflow-y', 'hidden');

              document.ontouchmove = function(event) {
                event.preventDefault();
              };
            }

            ui.helper.data('onOverCallback', onOverCallback);
          },
          stop: function(event, ui) {
            if (isMobile()) {
              editorBody.css('overflow-y', 'scroll');

              document.ontouchmove = null;
            }

            // No changes were made so we don't need to trigger an update.
            if (endDay == scope.dayIndex && endMemberId == scope.shift.staffMemberId) {
              return;
            }

            // Update the shift with the new day it has been dropped onto.
            // In the week view the time of the shift cannot be altered via
            // dragging so we preserve the original shift start and end times.
            var clockinTimeMoment = moment(scope.shift.clockinTime);
            var clockoutTimeMoment = moment(scope.shift.clockoutTime);

            // When a shift being updated crosses midnight, we need to make
            // sure that the end day remains on the next day from what the
            // shift was dropped onto. The day it was dropped onto is only the
            // correct date for the start time.
            const crossesMidnight = (clockinTimeMoment.day() + 1) === clockoutTimeMoment.day()

            scope.shift.clockinTime = moment(scope.viewStartDateTime)
              .add(endDay, 'days')
              .hour(clockinTimeMoment.hour())
              .minute(clockinTimeMoment.minute())
              .format();
            scope.shift.clockoutTime = moment(scope.viewStartDateTime)
              .add(crossesMidnight ? endDay + 1 : endDay, 'days')
              .hour(clockoutTimeMoment.hour())
              .minute(clockoutTimeMoment.minute())
              .format();

            scope.shift.breaks = moveBreaks(scope.shift.breaks, endDay);

            // Record the source staff member so we can perform updates to their overall cost.
            scope.shift.originalStaffMemberId = scope.shift.staffMemberId;
            // Then update the shift to belong to the destination staff member.
            scope.shift.staffMemberId = endMemberId;
            scope.updateShift(scope.shift);

            ui.helper.removeData('onOverCallback');
            endMemberId = null;
            endDay = null;
          }
        });

        /*
        * Configure the draggable fill icon to enable replicating a shift across adjacent days.
        */
        element.find('.shift-fill')
        .draggable({
          revert: true,
          revertDuration: 0,
          start: function(event, ui) {
            if (scope.shift.saving || scope.shift.datestampLocked != null) {
              //This kills the drag
              event.preventDefault();
              return;
            }

            ui.helper.data('startDay', scope.dayIndex);
            ui.helper.data('onOverCallback', onOverCallback);
          },
          stop: function(event, ui) {
            for (var copyIndex = scope.dayIndex + 1; copyIndex <= endDay; copyIndex++) {
              var daysDiff = copyIndex - scope.dayIndex;

              var newShift = angular.copy(scope.shift);
              delete newShift.id;
              newShift.clockinTime = moment(newShift.clockinTime).add(daysDiff, 'days').format();
              newShift.clockoutTime = moment(newShift.clockoutTime).add(daysDiff, 'days').format();
              newShift.breaks = copyBreaks(newShift.breaks, daysDiff);
              scope.addShift(newShift);
            }

            ui.helper.removeData('onOverCallback');
            endMemberId = null;
            endDay = null;
          }
        });

        var touchClassTimeout;

        /**
        * Store the currect scroll position so when the drag triggers we can compare and see if a scroll happened
        * Also add the drag class after the drag delay to show when to start dragging.
        */
        element.on('touchstart', function() {
          startTouchDragEditorScroll = editorBody.scrollTop();
          touchClassTimeout = $timeout(function() {
            if (editorBody.scrollTop() == startTouchDragEditorScroll && !scope.shift.saving) {
              element.addClass('ui-draggable-dragging');
            }
            touchClassTimeout = null;
          }, dragDelay);
        });

        // If the touch ends before the class delay was reached, cancel the timeout.
        element.on('touchend', function() {
          if (touchClassTimeout !== null) {
            $timeout.cancel(touchClassTimeout);
            touchClassTimeout = null;
          }

          element.removeClass('ui-draggable-dragging');
        });
      }

      element.on('click', function(e) {
        e.stopPropagation();

        element.removeClass('ui-draggable-dragging');

        // disable editing a day if any shifts are currently saving
        for (var i in scope.day) {
          var shift = scope.day[i];
          if (shift.saving) {
            return;
          }
        }

        //On iOS Safari, the click event can be triggered while dragging a shift. This will prevent the edit dialog from opening
        var dragData = angular.element(e.currentTarget).data('drag');
        if (typeof dragData != 'undefined' && dragData.moved) {
          return;
        }

        scope.openEditDialog({
          rosterCells: scope.day,
          staff: scope.staff,
          roles: scope.roles,
          saveCb: scope.save,
          startTime: scope.days[scope.dayIndex].startTime,
          index: scope.shiftIndex
        });
      });
    }
  };
}]);
